<template>
	<div class="stars-backdrop">
		<div class="backdrop-inner">
			<BackdropStar v-for="id in starCount" :key="id" />
		</div>
		<slot></slot>
	</div>
</template>

<script>
import BackdropStar from "@/components/partials/BackdropStar";

export default {
	name: 'StarBackdrop',
	components: {
		BackdropStar,
	},
	props: {
		starCount: {
			type: Number,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.stars-backdrop {
		width: 100%;
		height: 100%;
		position: relative;
		background-image: $sky-gradient;
		overflow: hidden;
	}

	.backdrop-inner {
		@include cover;
		pointer-events: none; // disabled during dev
	}
</style>



// WEBPACK FOOTER //
// src/components/partials/StarsBackdrop.vue